import { API_URL } from '../../../../../../actions/utilAction';
import { actionCreator,
    checkHttpStatus,
    create_post_data,
    createRequestActionTypes,
    createSearchUrl,
    extractDataFromObject,
    jsonApiHeader,
    showSuccessMessage,
    showErrorMessage
} from './../../../../../../actions/utilAction';

export { jsonApiHeader,
    actionCreator,
    checkHttpStatus,
    createSearchUrl,
    create_post_data,
    showSuccessMessage,
    showErrorMessage,
    extractDataFromObject, 
    API_URL,
};

export const GET_TARGET_LIST_API = `${API_URL}/api/MasterTargets/GetMasterTargets`;
export const POST_TARGET_API = `${API_URL}/api/MasterTargets/SaveMasterTarget`;
export const GET_TARGET_DETAILS_API = `${API_URL}/api/MasterTargets/GetMasterTargetById`;
export const DELETE_TARGET_API = `${API_URL}/api/MasterTargets/DeleteMasterTarget`;

export const TargetActionTypes = {
  get_targetList: createRequestActionTypes('GET_TARGETLIST'),
  post_target: createRequestActionTypes('POST_TARGET'),
  get_targetDetails: createRequestActionTypes('GET_TARGETDETAILS'),
  delete_target: createRequestActionTypes('DELETE_TARGET'),
};

export const MODULE = 'DCMASTER_TARGETS';





// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/curriculumLibraries/components/target/constants/ApiConstants.js